<template>
  <VerifyForm></VerifyForm>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { NavigationGuard } from "vue-router";

import store from "@/store";
import VerifyForm from "@/components/VerifyForm.vue";

const beforeRouteEnter: NavigationGuard = (to, from, next) => {
  // do not show verify page if waitingForConfirmation is null
  if (!store.getters.isWaitingForConfirmation) {
    return next({ name: "login" });
  } else {
    next();
  }
};

@Options<VerifyForm>({
  components: {
    VerifyForm,
  },

  beforeRouteEnter: beforeRouteEnter,
})
export default class Verify extends Vue {}
</script>
